import { sfOr } from 'spring-filter-query-builder';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

// TODO add more criteria
export const makeFirePermitFilter = (searchParam: string): string =>
    sfOr([sfLike('id', `${escapeSfqbString(searchParam, true)}*`, true)]).toString();
